import { P2GAlert, P2GButton, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { QuoteError } from '~/lib/types/basket-types';

type props = {
  onGetQuote?: () => void;
  errorMessages?: QuoteError[];
  onClose: () => void;
};

const NoResults: React.FC<props> = ({ onGetQuote, errorMessages, onClose }) => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  const navigate = useNavigate();
  const getQuote = () => (onGetQuote ? onGetQuote() : navigate({ pathname: `../quote` }, { relative: 'path' }));

  return (
    <P2GGrid container direction="column" spacing={2} dataTestId="service-switcher-error">
      <P2GGrid item>
        <P2GText variant="h2" dataTestId="service-switcher-error-title">
          {t('SERVICE_SWITCHER_NO_SERVICES_TITLE', { defaultValue: 'No Available Services' })}
        </P2GText>
      </P2GGrid>
      <P2GGrid item>
        <P2GText dataTestId="service-switcher-error-message">
          {t('SERVICE_SWITCHER_NO_SERVICES_MESSAGE', {
            defaultValue: `Unfortunately based on the details you have entered, we are unable to find a service which can take your parcel.`
          })}
        </P2GText>
      </P2GGrid>
      {errorMessages?.map((error, index) => (
        <P2GGrid item key={index}>
          <P2GAlert severity="error" dataTestId="service-switcher-error-alert">
            <P2GText dataTestId="service-switcher-error-message">{error.detail || error.title}</P2GText>
          </P2GAlert>
        </P2GGrid>
      ))}
      <P2GGrid item>
        <P2GGrid container spacing={2}>
          {errorMessages && errorMessages.length > 0 && (
            <P2GGrid item>
              <P2GButton onClick={onClose}>
                {t('SERVICE_SWITCHER_NO_SERVICES_FIX_BUTTON', {
                  defaultValue: `Fix the issue`
                })}
              </P2GButton>
            </P2GGrid>
          )}
          <P2GGrid item>
            <P2GButton onClick={getQuote} variant={errorMessages && errorMessages.length > 0 ? 'outlined' : undefined}>
              {t('SERVICE_SWITCHER_NO_SERVICES_BUTTON', {
                defaultValue: `Start a New Quote`
              })}
            </P2GButton>
          </P2GGrid>
        </P2GGrid>
      </P2GGrid>
    </P2GGrid>
  );
};
export default NoResults;
